"use strict";

import angular from "angular";
import { isDashboardBlockedByLicense } from "../../../entity/company-license";
import { CompanyStatusChange } from "../../../presentation/services/CompanyStatusChange";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import template from "./company-license-block.component.html";
import "./company-license-block.component.scss";

/**
 * Cobertura do dashboard de empresa sem licença: o painel continua atrás, desfocado e sem clique,
 * com um cartão explicando o motivo e o botão que ativa.
 *
 * O menu inteiro ficava trancado, e o contador tinha que decidir se queria a empresa antes de ver
 * qualquer coisa dela. Agora ele entra, navega no resto e decide olhando o painel embaçado — o que
 * o desfoque diz, e o menu trancado não dizia, é que existe dado do outro lado.
 *
 * O `pointer-events` é responsabilidade de quem embute (o contêiner do painel), porque é ele que
 * sabe qual pedaço da tela é o painel.
 */
class CompanyLicenseBlockComponent {
    constructor(
        $location,
        $scope,
        $mdDialog,
        DSNDialogService,
        CompanyDataService,
        AccountingDataService
    ) {
        this.$location = $location;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.CompanyDataService = CompanyDataService;
        this.AccountingDataService = AccountingDataService;
    }

    /**
     * O id da contabilidade, do binding ou do serviço.
     *
     * O cartão vive em cinco telas, e nem todas têm `accountingData` entre os bindings — as duas
     * de demonstrativos não têm. Exigir que cada host passasse o id transformaria cada tela nova
     * numa chance de esquecer, e o sintoma seria mudo: o cartão aparece, o botão abre o diálogo, e
     * a ativação falha sem dizer por quê.
     */
    getAccountingId() {
        return (
            this.accountingId ||
            this.AccountingDataService?.getEntity()?.props?._id ||
            null
        );
    }

    /**
     * Ativar é gesto de contador. O empresário alcança o painel da própria empresa, e para ele o
     * cartão explica a situação sem oferecer uma ação que o perfil dele não executa — o botão
     * abriria o fluxo de licença do escritório, com limite de plano e tudo.
     */
    canActivate() {
        const roles = new UserDataAdapter().user()?.roles || [];
        return !roles.includes("Empresa");
    }

    isBlocked() {
        return isDashboardBlockedByLicense({
            path: this.$location.path(),
            companyProps: this.CompanyDataService.get()?.props
        });
    }

    onActivate($event) {
        const company = this.CompanyDataService.get();
        if (!company) return;

        const companyStatusChange = new CompanyStatusChange({
            DSNDialogService: this.DSNDialogService,
            $mdDialog: this.$mdDialog,
            accountingId: this.getAccountingId()
        });

        companyStatusChange.execute(
            {
                $event,
                company: { _id: company.props._id, status: company.props.status }
            },
            ({ status }) => {
                // Sem atualizar a entidade em memória, ativar deixaria a empresa ativa no banco e o
                // painel embaçado na tela até o próximo F5 — o mesmo cuidado do selo no cabeçalho.
                this.CompanyDataService.setAttribute("status", status);
                this.$scope.$applyAsync();
            }
        );
    }
}

CompanyLicenseBlockComponent.$inject = [
    "$location",
    "$scope",
    "$mdDialog",
    "DSNDialogService",
    "CompanyDataService",
    "AccountingDataService"
];

const component = {
    bindings: {
        accountingId: "<"
    },
    controller: CompanyLicenseBlockComponent
};

const name = "companyLicenseBlockComponent";
const def = { ...component, template };
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
